import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function NationwideSection() {
  return <section id="cobertura" className="py-24 bg-espresso relative overflow-hidden" data-id="element-141" data-mp="5ywulll3iwru">
      {/* Subtle background pattern/texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-142" data-mp="3t4xgpfkc5ws6"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-143" data-mp="3j79mqruk0tb2">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-8" data-id="element-144" data-mp="35fbml6itm7r1">
          <MapPin className="w-8 h-8 text-gold" data-id="element-145" data-mp="imv45kictloy" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-5xl font-bold text-bone mb-8" data-id="element-146" data-mp="doa6nsuhlg47">
          Presencia <span className="text-gold italic" data-id="element-147" data-mp="3r3gaetjlq0od">Sin Fronteras</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-bone/80 font-light leading-relaxed max-w-4xl mx-auto" data-id="element-148" data-mp="8p6zo2uy4ztl">
          Nuestra planta de producción despacha y ensambla proyectos de gran
          escala en{' '}
          <span className="text-gold font-medium" data-id="element-149" data-mp="1gado6f423wg6">
            cualquier ciudad de Colombia
          </span>
          , garantizando puntualidad y acabados arquitectónicos superiores.
        </motion.p>
      </div>
    </section>;
}